import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {requestMapService} from "../../../jwt/_services";
import {error, FORM, info, infoMsg, REQUIRED, saveMsg, success, updateMsg} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function RequestMapForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        configAttribute: Yup.string().required(REQUIRED),
        url: Yup.string().required(REQUIRED)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            httpMethod: savedData?.httpMethod,
            url: savedData?.url,
            configAttribute: savedData?.configAttribute
        }
    });

    const onSubmit = (data, _) => {
        setLoading(true);
        const dataRequest = {
            id: data.id,
            httpMethod: data.httpMethod,
            configAttribute: data.configAttribute,
            url: data.url
        };
        if (!editMode) {
            //Save
            return requestMapService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            if (JSON.stringify(savedData) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            return requestMapService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }


    return (
        <Card>
            {loading && showLoader()}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>ID</Label>
                                <Input type="id" name="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>Atributo de configuración</Label>
                                <Input type="name" name="configAttribute"
                                       placeholder="Atributo de configuración"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.configAttribute ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="configAttribute" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Método Http</Label>
                                <Input type="httpMethod" name="httpMethod" placeholder="Método Http"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Url</Label><br/>
                                <Input type="name" name="url"
                                       placeholder="Dirección Url"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.url ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="url" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}